module.exports = __webpack_public_path__ + "img/F77777_FBE1E1_FAB2B2_FBC4C4-256px.a5e69744.png";